<template>
  <v-layout row wrap>
    <!-- Conditions List -->
    <v-flex :xs10="!conditionDetailsSheet" :xs5="conditionDetailsSheet">
      <v-data-table :headers="conditionsHeaders" :items="conditions">
        <template v-slot:items="props">
          <tr :active="
            !!selectedCondition && selectedCondition.id == props.item.id
          " class="pointer" @click="showConditionDetailsSheet(props.item)">
            <td class="text-xs-left">{{ props.item.title }}</td>
            <td class="text-xs-left">{{ props.item.conditionType }}</td>
            <td class="text-xs-left" v-if="!conditionDetailsSheet">
              {{ props.item.field }}
            </td>
            <td class="text-xs-left" v-if="!conditionDetailsSheet">
              {{ props.item.severity }}
            </td>
            <td class="justify-center layout px-0 pointer" width="10%">
              <v-icon small @click.stop="showConditionDetailsSheet(props.item)" class="mr-2">
                mdi-circle-edit-outline
              </v-icon>
              <v-icon small @click.stop="showDeleteConditionDialog(props.item)"
                class="error--text text--lighten-1 mr-1">
                delete
              </v-icon>
            </td>
          </tr>
        </template>
        <!-- No Data -->
        <template slot="no-data">
          <v-alert :value="true" color="info" class="black--text" icon="info">
            {{ messages.info.NO_CONDITIONS }}
          </v-alert>
        </template>
      </v-data-table>
    </v-flex>
    <!-- Conditions Details Sheet -->
    <v-flex xs7 v-show="conditionDetailsSheet">
      <ConditionDetails />
    </v-flex>
    <v-flex xs2 class="text-xs-left" v-show="!conditionDetailsSheet">
      <v-btn color="primary" flat round @click="showConditionDetailsSheet()">
        <v-icon left>add_circle</v-icon><span>{{ messages.label.ADD_CONDITION }}</span>
      </v-btn>
    </v-flex>
    <!-- Delete dialog -->
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-card-title class="subheading ttu">
          {{ messages.label.DELETE_CONDITION }}
        </v-card-title>
        <v-card-text>
          <p>
            {{ messages.info.DELETE_CONDITION_MSG }}
            <b>{{ conditionToDelete.title }}</b> ?
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1 white--text" @click="deleteDialog = false">
            {{ messages.label.CANCEL }}
          </v-btn>
          <v-btn color="error" @click="deleteCondition(conditionToDelete)">
            {{ messages.label.DELETE }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import messages from "@/XVAT/messages.json"
import ConditionDetails from "@/XVAT/Rule/ConditionDetails"
import XVATRulesService from "@/XVAT/XVATRulesService"

export default {
  name: "RuleConditions",
  components: {
    ConditionDetails
  },
  data() {
    return {
      conditionDetailsSheet: false,
      deleteDialog: false,
      selectedCondition: {},
      conditionToDelete: {},
      conditions: []
    }
  },
  computed: {
    conditionsHeaders() {
      return this.getConditionsHeaders()
    }
  },
  methods: {
    /**
     * getConditionsHeaders - Conditions data table headers
     * @returns {array}
     */
    getConditionsHeaders() {
      let defaultHeaders = [
        {
          text: "Title",
          align: "left",
          value: "title"
        },
        { text: "Type", value: "conditionType" }
      ]
      if (this.conditionDetailsSheet) {
        defaultHeaders.push({ text: "", sortable: false })
        return defaultHeaders
      } else {
        defaultHeaders.push({ text: "Field", value: "field" })
        defaultHeaders.push({ text: "Severity", value: "severity" })
        defaultHeaders.push({ text: "", sortable: false })
        return defaultHeaders
      }
    },

    /**
     * showConditionDetailsSheet - Show condition details
     */
    showConditionDetailsSheet(condition) {
      if (!this.$lodash.isUndefined(condition)) {
        this.selectedCondition = condition
      } else {
        this.selectedCondition = {}
      }
      this.conditionDetailsSheet = true
      XVATRulesService.$emit("event:showConditionDetailsSheet", condition)
    },

    /**
     * hideConditionDetailsSheet - Hide condition details view
     */
    hideConditionDetailsSheet() {
      this.conditionDetailsSheet = false
      this.selectedCondition = {}
    },

    /**
     * resetData - Reset data
     */
    resetData() {
      this.selectedCondition = {}
      this.conditions = []
    },

    /**
     * addCondition - Add new condition
     * @param {object} condition
     */
    addCondition(condition) {
      this.conditions.push(condition)
      XVATRulesService.$emit("event:validateForUpdateRule")
    },

    /**
     * updateCondition - Update existing condition
     * @param {object} condition
     */
    updateCondition(condition) {
      let conditionIndex = -1
      conditionIndex = this.$lodash.findIndex(this.conditions, conditionObj => {
        return conditionObj.id === condition.id
      })
      if (conditionIndex !== -1) {
        this.conditions.splice(conditionIndex, 1, condition)
      }
      XVATRulesService.$emit("event:validateForUpdateRule")
    },

    /**
     * showDeleteConditionDialog - Show dialog to delete condition
     */
    showDeleteConditionDialog(condition) {
      this.deleteDialog = true
      this.conditionToDelete = condition
    },

    /**
     * deleteCondition - Delete existing condition
     * @param {object} condition
     */
    deleteCondition(condition) {
      let conditionIndex = -1
      conditionIndex = this.$lodash.findIndex(this.conditions, conditionObj => {
        return conditionObj.id === condition.id
      })
      if (conditionIndex !== -1) {
        this.conditions.splice(conditionIndex, 1)
        this.deleteDialog = false
        this.hideConditionDetailsSheet()
        //XVATRulesService.$emit("event:displaySaveRuleMsg")
        XVATRulesService.$emit("event:validateForUpdateRule")
      }
    },

    /**
     * loadConditions - load conditions
     */
    loadConditionsData(data) {
      this.resetData()
      // NOTE: Parse conditions object from string to object
      if (!this.$lodash.isUndefined(data) && data.conditions.length > 0) {
        this.conditions = XVATRulesService.addUniqIds(
          data.conditions
        )
      }
    },

    /**
     * validateConditions -
     */
    validateConditions() {
      // NOTE: For now passing 'true' but need to comeback and re-evaluate
      XVATRulesService.$emit(
        "event:ruleConditionsValidation",
        true,
        this.conditions
      )
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages

    /**
     * Events
     */
    XVATRulesService.$on("event:ruleDataRetrieved", this.loadConditionsData)
    XVATRulesService.$on("event:validteConditions", this.validateConditions)
    XVATRulesService.$on("event:addCondition", this.addCondition)
    XVATRulesService.$on("event:updateCondition", this.updateCondition)
    XVATRulesService.$on("event:deleteCondition", this.deleteCondition)
    XVATRulesService.$on(
      "event:hideConditionDetailsSheet",
      this.hideConditionDetailsSheet
    )
  },
  beforeDestroy() {
    XVATRulesService.$off(
      "event:ruleDataRetrieved",
      this.loadConditionsData
    )
    XVATRulesService.$off(
      "event:validteConditions",
      this.validateConditions
    )
    XVATRulesService.$off("event:addCondition", this.addCondition)
    XVATRulesService.$off("event:updateCondition", this.updateCondition)
    XVATRulesService.$off("event:deleteCondition", this.deleteCondition)
    XVATRulesService.$off(
      "event:hideConditionDetailsSheet",
      this.hideConditionDetailsSheet
    )
  }
}
</script>
<style lang="sass"></style>



// WEBPACK FOOTER //
// src/XVAT/Rule/RuleConditions.vue